// generated from 5_766 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithWorkflowStepInternalCanvasTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithWorkflowStepinternal_canvas"),
  eligible_workflow_steps: z.null(),
  interaction: z.enum([
    "oe", // 859 (14.90%)
    "ti", // 692 (12.00%)
    "re", // 676 (11.72%)
    "rs", // 676 (11.72%)
    "rp", // 676 (11.72%)
    "rw", // 676 (11.72%)
    "tia", // 676 (11.72%)
    "wsa", // 306 (5.31%)
    "ce", // 228 (3.95%)
    "rc", // 223 (3.87%)
    "op", // 78 (1.35%)
  ]),
  // undefined: 4_585 (79.52%), defined 1_181 (20.48%)
  is_exception_event: z.literal(true).optional(),
  selected_carousel_slide_id: z.null(),
  selected_carousel_slide_name: z.null(),
  selected_push_button_name: z.null(),
  selected_push_button_string: z.null(),
  // null: 9 (0.16%)
  selected_workflow_id: common.objectId.nullable(),
  // null: 9 (0.16%)
  selected_workflow_name: z.string().nullable(),
  // null: 8 (0.14%)
  selected_workflow_step_id: common.objectId.nullable(),
  // null: 8 (0.14%)
  selected_workflow_step_name: z.string().nullable(),
});
